<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div (keyup.enter)="submit()">
  <app-user-header header="Sign up"></app-user-header>

  <div fxLayout="row wrap" fxLayoutAlign="space-around center">
    <form [formGroup]="signUpForm">
      <div>
        <input
          id="name"
          formControlName="userName"
          type="text"
          placeholder="Enter your name"
          class="notranslate nvc-input nvc-input-width"
          i18n-placeholder
        />
        <div *ngIf="userName.invalid && (userName.touched || userName.dirty)">
          <small
            class="error notranslate"
            *ngIf="userName.errors"
            i18n="@@Username_is_required"
            >User name is required</small
          >
        </div>
      </div>

      <div>
        <input
          id="userdetails"
          formControlName="userDetails"
          type="text"
          placeholder="Enter phone number or email"
          i18n-placeholder
          class="notranslate nvc-input nvc-input-width"
        />
        <div
          *ngIf="
            userDetails.invalid && (userDetails.touched || userDetails.dirty)
          "
        >
          <small
            id="userdetailsreq"
            class="error notranslate"
            i18n="@@User_details_are_required"
            *ngIf="userDetails.errors?.required"
            >User details are required</small
          >
          <small
            id="userdetailsinvalid"
            class="error notranslate"
            i18n="@@User_details_are_invalid"
            *ngIf="userDetails.errors?.pattern"
            >User details are invalid</small
          >
        </div>
      </div>

      <div class="nvc-input-div">
        <div
          class="nvc-input nvc-input-width"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <input
            id="password"
            fxFlex="90"
            formControlName="userPassword"
            [type]="passwordType"
            placeholder="Enter Password"
            i18n-placeholder
            class="notranslate nvc-input nvc-input-tag"
          />
          <mat-icon
            [svgIcon]="passwordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
            class="nvc-eye ws-cursor-pointer"
            (click)="togglePasswordVisibility()"
          >
          </mat-icon>
        </div>
      </div>
      <div
        *ngIf="
          userPassword.invalid && (userPassword.touched || userPassword.dirty)
        "
      >
        <small
          class="error notranslate"
          i18n="@@User_Password_is_required"
          *ngIf="userPassword.errors?.required"
          >User Password is required</small
        >
        <small
          class="error notranslate"
          i18n="@@User_Password_must_be"
          *ngIf="userPassword.errors?.minlength"
          >User Password must be at least 8 characters</small
        >
      </div>

      <button
        id="createaccount"
        [ngClass]="{ 'nvc-disabled': !validCredentials() }"
        class="signup-button notranslate"
        type="submit"
        (click)="verificationFunction()"
        [disabled]="signUpForm.invalid"
        i18n
      >
        CREATE ACCOUNT
      </button>
    </form>
  </div>
  <div
    *ngIf="userError"
    fxLayout="column"
    fxLayoutAlign="space-around center"
    class="error translate"
  >
    <small id="usererror">{{ userErrorMessage }}</small>
  </div>
  <div
    fxLayout="column"
    fxLayoutAlign="space-around center"
    class="fsmall spacing"
  >
    <div class="translate">
      By creating an account,you agree to our
      <strong>Terms of Service</strong> and
      <strong (click)="redirectPrivacyPolicy()">Privacy Policy</strong>
    </div>
  </div>
</div>
